/**
 * @file: index.ts
 * @author: eric <eric.blueplus@gmail.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { StatusColors } from '@euler/components/Colors';
import { FontFamily } from '@euler/components/typography';
import {
  InspectionTaskEventSubType,
  InspectionTaskEventType,
} from '@euler/model/enum';
import { registerEventType } from '../../registry';

const register = registerEventType(InspectionTaskEventType.Quotation);

function quotationInitiated() {
  register(InspectionTaskEventSubType.QuotationInitiated)(item => {
    item.label('填写维修报价单完成');
  });
}

function quotationSubmitted() {
  register(InspectionTaskEventSubType.QuotationSubmitted)(item => {
    item.label('维修报价单已提交至前台');
  });
}

function quotationAmendRequested() {
  register(InspectionTaskEventSubType.QuotationAmendRequested)(item => {
    item.label({
      text: '修改维修报价单',
      fontFamily: FontFamily.NotoSans.Medium,
      color: StatusColors.Warn,
    });
  });
}

function quotationConfirmed() {
  register(InspectionTaskEventSubType.QuotationConfirmed)((item, data) => {
    item
      .label({
        text: '维修报价单已确认',
        fontFamily: FontFamily.NotoSans.Medium,
        color: StatusColors.Success,
      })
      .tagline({
        text: `单号: ${data.formNo}`,
      });
  });
}

function quotationFinished() {
  register(InspectionTaskEventSubType.QuotationFinished)(item => {
    item.label('维修报价完成');
  });
}

quotationInitiated();
quotationSubmitted();
quotationConfirmed();
quotationFinished();
quotationAmendRequested();
